import React from "react";

// Функция для безопасного создания URL из файла
const createSafeObjectURL = (file) => {
  try {
    if (file && file instanceof File) {
      return URL.createObjectURL(file);
    }
    return null;
  } catch (error) {
    console.error('Error creating object URL:', error);
    return null;
  }
};

export default function MaterialPreviewModal({ previewMaterial, handleClosePreview }) {
  if (!previewMaterial) return null;

  return (
    <div className="custom-modal-overlay" onClick={handleClosePreview}>
                  <div className="custom-modal preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="custom-modal-header">
          <h3 title={previewMaterial.name}>
            {previewMaterial.name.length > 50
              ? previewMaterial.name.substring(0, 50) + '...'
              : previewMaterial.name
            }
          </h3>
                          <button className="custom-modal-close" onClick={handleClosePreview}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
        </div>
                    <div className="custom-modal-body preview-body">
          {previewMaterial.name.toLowerCase().endsWith('.pdf') ? (
            <div className="preview-content">
              <div className="pdf-preview">
                {previewMaterial.file ? (
                  <div className="pdf-container">
                    <iframe
                      src={previewMaterial.file ? (createSafeObjectURL(previewMaterial.file) || previewMaterial.value) + '#toolbar=0&navpanes=0&scrollbar=0' : previewMaterial.value}
                      width="100%"
                      height="400px"
                      title="PDF Preview"
                      className="pdf-iframe"
                      frameBorder="0"
                      onLoad={(e) => {
                        // Убираем сообщение "текст извлекается" если возможно
                        try {
                          const iframe = e.target;
                          if (iframe.contentDocument) {
                            iframe.contentDocument.body.style.overflow = 'hidden';
                          }
                        } catch (error) {
                          // Игнорируем ошибки CORS
                        }
                      }}
                    />
                    <div className="pdf-overlay">
                      <p>PDF Document Preview</p>
                      <small>Use browser controls to navigate</small>
                    </div>
                  </div>
                ) : (
                  <div className="file-fallback">
                    <svg width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g transform="translate(22 4.998)">
                        <path d="m87-4.9980469c-33.051062 0-60 26.9489439-60 59.9999999v391.999997c0 33.05087 26.94887 60 60 60h294c33.05093 0 60-26.94906 60-60v-294.0039c0-18.59674-7.39309-36.44387-20.54297-49.59375l-87.85937-87.859378c-13.1499-13.1498723-30.99506-20.5429733-49.5918-20.5429689zm48.99414 146.9980469h98a10.9995 10.9995 0 0 1 11 11 10.9995 10.9995 0 0 1 -11 10.99805l-98 .002a10.9995 10.9995 0 0 1 -11-11 10.9995 10.9995 0 0 1 11-11zm0 98h196a11.00005 11.00005 0 0 1 11 11 11.00005 11.00005 0 0 1 -11 11h-196a11.00005 11.00005 0 0 1 -11-11 11.00005 11.00005 0 0 1 11-11zm.004 97.99609h195.99804a11.00005 11.00005 0 0 1 11.00196 11 11.00005 11.00005 0 0 1 -11.00196 11h-195.99813a11.00005 11.00005 0 0 1 -11.00196-11 11.00005 11.00005 0 0 1 11.00196-11z" clipRule="evenodd" fillRule="evenodd" strokeWidth="22" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" fill="#ee5a24" stroke="#ee5a24"/>
                      </g>
                    </svg>
                    <p>PDF not available for preview</p>
                  </div>
                )}
                <div className="file-info">
                  <p><strong>Type:</strong> PDF Document</p>
                  <p><strong>Added:</strong> {previewMaterial.dateOfUpload}</p>
                </div>
              </div>
            </div>
          ) : /\.(mp4|avi|mov|wmv|flv|webm|mkv|m4v|3gp|ogv)$/i.test(previewMaterial.name) ? (
            <div className="preview-content">
              <div className="video-preview">
                {previewMaterial.file ? (
                  <video
                    controls
                    width="100%"
                    height="300px"
                    className="video-player"
                  >
                    <source src={previewMaterial.file ? (createSafeObjectURL(previewMaterial.file) || previewMaterial.value) : previewMaterial.value} type="video/mp4" />
                    <source src={previewMaterial.file ? (createSafeObjectURL(previewMaterial.file) || previewMaterial.value) : previewMaterial.value} type="video/webm" />
                    <source src={previewMaterial.file ? (createSafeObjectURL(previewMaterial.file) || previewMaterial.value) : previewMaterial.value} type="video/ogg" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div className="file-fallback">
                    <svg width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g transform="translate(22 -5.002)">
                        <path d="m87 5.0019531c-33.051057 0-60 26.9489429-60 59.9999999v391.999997c0 33.05087 26.948875 60 60 60h294c33.05113 0 60-26.94913 60-60v-294.0039c.00001-18.59674-7.39309-36.44387-20.54297-49.59375l-87.85937-87.859378c-13.1499-13.149868-30.99507-20.5429708-49.5918-20.5429689zm171.49023 171.4999969c18.8388-.00061 34.30991 15.02645 35.31641 33.63282l13.08008-13.08399c6.33207-6.33433 15.81761-7.58586 23.05273-4.58984 7.23513 2.996 13.06044 10.58839 13.06055 19.54492v97.97852c.00014 8.95722-5.82512 16.54783-13.06055 19.54492-7.23541 2.99708-16.72088 1.74763-23.05468-4.58594l-13.07422-13.07422c-1.0024 18.60473-16.47207 33.63294-35.3086 33.63281h-98.0039c-19.47443.00008-35.49793-16.02364-35.49805-35.49804v-24.49805a11.00005 11.00005 0 0 1 11-11 11.00005 11.00005 0 0 1 11 11v24.49805c.00005 7.58455 5.91315 13.49807 13.49805 13.49804h98.0039c7.58489.00005 13.49802-5.91349 13.49805-13.49804v-24.49805a11.00115 11.00115 0 0 1 18.77734-7.7793l30.22266 30.22071v-93.89844l-30.2207 30.23437a11.00115 11.00115 0 0 1 -18.7793-7.77734l-.002-24.5c-.00081-7.5889-5.91858-13.50415-13.50782-13.50391l-97.98632.004c-7.58892.00027-13.50395 5.91531-13.50391 13.50391v24.49804a11.00005 11.00005 0 0 1 -11 11 11.00005 11.00005 0 0 1 -11-11v-24.49804c-.00009-19.47821 16.02568-35.50517 35.50391-35.50586z" clipRule="evenodd" fillRule="evenodd" strokeWidth="22" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" fill="#ee5a24" stroke="#ee5a24"/>
                      </g>
                    </svg>
                    <p>Video not available for preview</p>
                  </div>
                )}
                <div className="file-info">
                  <p><strong>Type:</strong> Video File</p>
                  <p><strong>Added:</strong> {previewMaterial.dateOfUpload}</p>
                </div>
              </div>
            </div>
          ) : /\.(jpg|jpeg|png|gif|bmp|svg|webp|ico|tiff|tif)$/i.test(previewMaterial.name) ? (
            <div className="preview-content">
              <div className="image-preview">
                {previewMaterial.file ? (
                  <img
                    src={previewMaterial.file ? (createSafeObjectURL(previewMaterial.file) || previewMaterial.value) : previewMaterial.value}
                    alt={previewMaterial.name}
                    className="preview-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                ) : null}
                <div className="image-fallback" style={{display: previewMaterial.file ? 'none' : 'flex'}}>
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="#ee5a24" stroke="#ee5a24" strokeWidth="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
                    <polygon points="21,15 16,10 5,21" fill="white"/>
                  </svg>
                  <p>Image not available for preview</p>
                </div>
                <div className="file-info">
                  <p><strong>Type:</strong> Image File</p>
                  <p><strong>Added:</strong> {previewMaterial.dateOfUpload}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="preview-content">
              <div className="file-preview">
                <div className="file-icon">
                  <svg width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(22 4.998)">
                      <path d="m87-4.9980469c-33.051062 0-60 26.9489439-60 59.9999999v391.999997c0 33.05087 26.94887 60 60 60h294c33.05093 0 60-26.94906 60-60v-294.0039c0-18.59674-7.39309-36.44387-20.54297-49.59375l-87.85937-87.859378c-13.1499-13.1498723-30.99506-20.5429733-49.5918-20.5429689zm48.99414 146.9980469h98a10.9995 10.9995 0 0 1 11 11 10.9995 10.9995 0 0 1 -11 10.99805l-98 .002a10.9995 10.9995 0 0 1 -11-11 10.9995 10.9995 0 0 1 11-11zm0 98h196a11.00005 11.00005 0 0 1 11 11 11.00005 11.00005 0 0 1 -11 11h-196a11.00005 11.00005 0 0 1 -11-11 11.00005 11.00005 0 0 1 11-11zm.004 97.99609h195.99804a11.00005 11.00005 0 0 1 11.00196 11 11.00005 11.00005 0 0 1 -11.00196 11h-195.99813a11.00005 11.00005 0 0 1 -11.00196-11 11.00005 11.00005 0 0 1 11.00196-11z" clipRule="evenodd" fillRule="evenodd" strokeWidth="22" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"/>
                    </g>
                  </svg>
                </div>
                <div className="file-info">
                  <p><strong>Type:</strong> {previewMaterial.type}</p>
                  <p><strong>Added:</strong> {previewMaterial.dateOfUpload}</p>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Убираем футер с кнопкой Close, так как есть крестик сверху */}
      </div>
    </div>
  );
}
